import { API_URL } from '../../../../../../utils/config';

const ProfileUrl = {
  CREATE_PROFILE_URL: `${API_URL}/open5gs/profiles`,
  GET_PROFILES_URL: `${API_URL}/open5gs/profiles`,
};

export default ProfileUrl;
